import React, { FC, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import TabContext from '../../common/Tabs/TabContext/TabContext';
import Tabs from '../../common/Tabs/Tabs/Tabs';
import Tab from '../../common/Tabs/Tab/Tab';
import TabPanel from '../../common/Tabs/TabPanel/TabPanel';

interface AdminGlobalSettingsProps { }


const AdminGlobalSettings: FC<AdminGlobalSettingsProps> = () => {
  const location = useLocation();
  const [tab, setTab] = useState<string>('bulletins');
  const navigate = useNavigate();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => navigate(`./${newValue}`);

  useEffect(() => {
    const path = location.pathname.split('/').pop();
    const availableTabs: string[] = ['bulletins', 'warranty-registration-search'];
    const matchedTab = availableTabs.find((tab) => tab === path);
    setTab(matchedTab ?? 'bulletins');
  }, [location, setTab])

  return (
    <>
      <TabContext value={tab}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          value={tab}
          onChange={handleTabChange}
          sx={(theme) => ({
            width: '100%',
            marginRight: "12px",
            [theme.breakpoints.down('desktop')]: {
              marginBottom: "12px",
            },
            [theme.breakpoints.down('tablet')]: {
              justifyContent: "center",
              marginRight: "0px"
            }
          })}>
          {/* <Tab label="General" value="general" /> */}
          <Tab label="Bulletins" value="bulletins" />
          <Tab label="Warranty Registration Search" value="warranty-registration-search" />
        </Tabs>
        <TabPanel value={tab}>
          <Outlet />
        </TabPanel>
      </TabContext>
    </>
  );
}

export default AdminGlobalSettings;
